import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs";
import { quillConfiguration } from "src/app/quill-configuration";
import { TextFormatingService } from "src/app/services/ui/textFormating.service";

@Component({
  selector: "app-rich-text",
  templateUrl: "./rich-text.component.html",
  styleUrls: ["./rich-text.component.scss"],
})
export class RichTextComponent implements OnInit {
  @Input() dicaEstudo: string;
  @Input() editorDicaEstudo: boolean;
  @Output() onEditDicas = new EventEmitter<string>();
  public quillConfiguration = quillConfiguration;

  public fontIncrement$: Observable<number>;

  constructor(private textFormatingService: TextFormatingService) {}

  ngOnInit() {
    this.fontIncrement$ = this.textFormatingService.getFontIncrement();
  }

  editDicas(event) {
    this.dicaEstudo = event.html;
    this.onEditDicas.emit(this.dicaEstudo);
  }
}
